export const ConsultationTypes = {
  Inpatient: 'INPATIENT',
  Outpatient: 'OUTPATIENT',
  HomeCall: 'HOME_CALL',
  FarmVisit: 'FARM_VISIT',
  Boarding: 'BOARDING',
  PetService: 'PET_SERVICE',
} as const

export const ConsultationStatuses = {
  CheckedIn: 'ADMITTED',
  InProgress: 'CONSULTATION',
  ReadyToDischarge: 'WAITING_FOR_DISCHARGE',
  Invoicing: 'INVOICING',
  Discharged: 'DISCHARGED',
  InvoicePaid: 'INVOICE_PAID',
  Finalized: 'FINALIZED',
  Draft: 'DRAFT',
} as const

export type ConsultationPatientType =
  (typeof ConsultationPatientTypes)[keyof typeof ConsultationPatientTypes]
export const ConsultationPatientTypes = {
  FirstOpinionCase: 'FIRST_OPINION_CASE',
  ReferredPatient: 'REFERRED_PATIENT',
} as const
